import { Component, OnInit, HostListener, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { AuthService } from "src/app/services/auth.service";
import { SignInComponent } from "../../login/sign-in/sign-in.component";
import { BookDemoDialogComponent } from "../../form/book-demo-dialog/book-demo-dialog.component";
import { catchError, map, throwError } from "rxjs";
import { ProfileService } from "src/app/modules/myVirsa/services/profile.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { transform } from "src/app/utils/date-utils";
import { MatMenuTrigger } from "@angular/material/menu";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  @ViewChild('productsMenuTrigger') productsMenuTrigger!: MatMenuTrigger;
  @ViewChild('solutionsMenuTrigger') solutionsMenuTrigger!: MatMenuTrigger;
  Cap(arg0: string): string {
    return transform(arg0);
  }
  isProductsExpanded = false;
  isSolutionsExpanded = false;
  genrelist = [
    { id: "learn-flute-online", name: "Flute" },
    { id: "bharatnatyam-online-classes", name: "Bharatnatyam" },
    { id: "keyboard-online-classes", name: "Keyboard" },
    { id: "learn-harmonium-online", name: "Harmonium" },
    { id: "online-guitar-classes", name: "Guitar" },
    { id: "carnatic-vocal-classes", name: "Carnatic Vocal" },
    { id: "hindustani-vocal-classes", name: "Hindustani Classical Vocal" },
    { id: "online-sitar-classes", name: "Sitar" },
    { id: "kathak-dance-online-classes", name: "Kathak" },
    { id: "online-theatre-courses", name: "Theatre" },
    { id: "tabla-classes-online", name: "Tabla" },
  ];
  userSignedIn: boolean = false;
  isProfileDropdownOpen: boolean = false;
  isNavListVisible: boolean = false;
  data: any;

  constructor(
    private router: Router,
    private auth: AuthService,
    private dialog: MatDialog,
    private profile: ProfileService,
    private snackbar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.checkLogin();
    // Open first menu dropdown by default (Products) on mobile
    if (window.innerWidth <= 1024) {
      this.isProductsExpanded = true;
    }
  }

  // toggleNavList(is = "real") {
  //   if (is == "real") this.isNavListVisible = !this.isNavListVisible;
  //   else if (is == "set") {
  //     if (this.isNavListVisible) {
  //       this.isNavListVisible = !this.isNavListVisible;
  //     }
  //   }
  // }

  // Function to toggle the profile dropdown
  toggleProfileDropdown() {
    this.isProfileDropdownOpen = !this.isProfileDropdownOpen;
  }

  getData(): void {
    this.profile
      .getProfile()
      .pipe(
        map((res: any) => {
          this.data = res.details;
        }),
        catchError((error) => {
          return throwError(error.massage || error);
        })
      )
      .subscribe();
  }

  openBookDemo() {
    const dialogRef = this.dialog.open(BookDemoDialogComponent, {
      width: '100%',
      maxWidth: '500px',
      panelClass: 'book-demo-dialog',
      data: {}
    });
  }

  openLogIn() {
    const dialogRef = this.dialog.open(SignInComponent, {
      enterAnimationDuration: "200ms",
      data: {},
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.checkLogin();
    });
  }

  checkLogin() {
    if (this.auth.isLoggedIn()) {
      this.userSignedIn = true;
      this.getData();
    } else {
      this.userSignedIn = false;
    }
  }

  signOut() {
    this.auth.logout();
    this.snackbar.open("SignOut Successful", "Ok", { duration: 4000 });
    this.checkLogin();
    this.router.navigate(["/"]);
  }

  toggleNavList(action?: string) {
    if (action === 'set') {
      this.isNavListVisible = false;
      this.isProductsExpanded = false;
      this.isSolutionsExpanded = false;
    } else {
      this.isNavListVisible = !this.isNavListVisible;
      if (!this.isNavListVisible) {
        this.isProductsExpanded = false;
        this.isSolutionsExpanded = false;
      }
    }
  }

  // Toggle products dropdown in mobile view
  toggleProductsDropdown() {
    if (window.innerWidth <= 1024) {
      // Mobile behavior - expand/collapse
      this.isProductsExpanded = !this.isProductsExpanded;
    }
  }

  // Toggle solutions dropdown in mobile view
  toggleSolutionsDropdown() {
    if (window.innerWidth <= 1024) {
      // Mobile behavior - expand/collapse
      this.isSolutionsExpanded = !this.isSolutionsExpanded;
    }
  }

  productsMenuTimer: any;
  solutionsMenuTimer: any;

  openProductsMenu() {
    if (window.innerWidth > 1024) {
      clearTimeout(this.productsMenuTimer);
      if (!this.productsMenuTrigger.menuOpen) {
        this.productsMenuTrigger.openMenu();
      }
    }
  }

  closeProductsMenu() {
    if (window.innerWidth > 1024) {
      this.productsMenuTimer = setTimeout(() => {
        this.productsMenuTrigger.closeMenu();
      }, 300);
    }
  }

  openSolutionsMenu() {
    if (window.innerWidth > 1024) {
      clearTimeout(this.solutionsMenuTimer);
      if (!this.solutionsMenuTrigger.menuOpen) {
        this.solutionsMenuTrigger.openMenu();
      }
    }
  }

  closeSolutionsMenu() {
    if (window.innerWidth > 1024) {
      this.solutionsMenuTimer = setTimeout(() => {
        this.solutionsMenuTrigger.closeMenu();
      }, 300);
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    if (this.isNavListVisible) {
      const target = event.target as HTMLElement;
      if (!target.closest('.nav_link_list') && !target.closest('.menu-btn')) {
        this.isNavListVisible = false;
        this.isProductsExpanded = false;
        this.isSolutionsExpanded = false;
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    // Close mobile dropdowns when screen size changes to desktop
    if (window.innerWidth > 1024) {
      this.isNavListVisible = false;
      this.isProductsExpanded = false;
      this.isSolutionsExpanded = false;
    }
  }
}

